<template>
  <BaseDialog
    :is-open="isOpen"
    @close="$emit('close')"
    type="basic"
    :title="$t('dialog.coachRelease.title')"
  >
    <p class="text-body-large">
      {{ $t('dialog.coachRelease.description') }}
    </p>
    <div
      class="bg-tertiary-container text-on-tertiary-container rounded-medium mt-4 flex items-center gap-3 p-4"
    >
      <BaseIcon size="24">warning</BaseIcon>
      <p class="text-body-medium">{{ $t('dialog.coachRelease.warning') }}</p>
    </div>
    <template #confirm>
      <BaseTextButton
        color="filled"
        size="M"
        :disabled="disabled"
        @click="$emit('coachReleaseDialog')"
        >{{ $t('dialog.releaseCoach.action') }}</BaseTextButton
      >
    </template>
    <template #dismiss>
      <BaseTextButton @click="$emit('close')" size="M">{{ $t('common.cancel') }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'

  interface Props {
    isOpen: boolean
    disabled?: boolean
  }

  defineProps<Props>()

  defineEmits<{
    (e: 'close'): void
    (e: 'coachReleaseDialog'): void
  }>()
</script>
